import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { sendHoverSoundCommand, sendSelectClickSoundCommand } from 'react-wot-bootstrap'

import styles from './Paginator.scss'

class Paginator extends React.PureComponent {
    constructor(props) {
        super(props)

        this.handlePrevClick = this.handlePrevClick.bind(this)
        this.handleNextClick = this.handleNextClick.bind(this)
    }

    handlePrevClick() {
        this.props.onPrevClick()
    }

    handleNextClick() {
        this.props.onNextClick()
    }

    render() {
        const classNamePrev = cx(styles.control, styles['control__prev'], {
            [styles.isDisabled]: this.props.current <= 1,
        })

        const classNameNext = cx(styles.control, styles['control__next'], {
            [styles.isDisabled]: this.props.current >= this.props.total,
        })

        const prevDataAttrs = this.props.prevTooltipId ? {
            'data-tip': true,
            'data-for': this.props.prevTooltipId,
        } : {}

        const nextDataAttrs = this.props.nextTooltipId ? {
            'data-tip': true,
            'data-for': this.props.nextTooltipId,
        } : {}

        const isPrevEnabled = this.props.current > 1
        const isNextEnabled = this.props.current < this.props.total
        return (
            <div className={cx(styles.base, this.props.className)}>
                <span
                    {...prevDataAttrs}
                    className={classNamePrev}
                    onClick={isPrevEnabled ? this.handlePrevClick : null}
                    onMouseDown={isPrevEnabled ? sendSelectClickSoundCommand : null}
                    onMouseEnter={isPrevEnabled ? sendHoverSoundCommand : null}
                    tabIndex="-1"
                />
                <span className={styles.current}>{this.props.current}</span>
                <span className={styles.divider}>{'/'}</span>
                <span className={styles.total}>{this.props.total}</span>
                <span
                    {...nextDataAttrs}
                    className={classNameNext}
                    onClick={isNextEnabled ? this.handleNextClick : null}
                    onMouseDown={isNextEnabled ? sendSelectClickSoundCommand : null}
                    onMouseEnter={isNextEnabled ? sendHoverSoundCommand : null}
                    tabIndex="-1"
                />
            </div>
        )
    }
}

Paginator.propTypes = {
    total: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    current: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    onPrevClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired,
    prevTooltipId: PropTypes.string,
    nextTooltipId: PropTypes.string,
    className: PropTypes.string,
}

export default Paginator



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Paginator/Paginator.jsx